export const getRootDomain = (hostname) => {
    if (hostname === 'localhost' || /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)) {
        return hostname
    }
    const allowedTwoPartTlds = ['co.uk']
    const parts = hostname.split('.')
    const lastTwo = parts.slice(-2).join('.')
    if (allowedTwoPartTlds.includes(lastTwo) && parts.length > 2) {
        return parts.slice(-3).join('.')
    }
    return lastTwo
}
